/*
 * Who the public pages read as (2026-10-26, ENHANCEMENTS S46) - apart from
 * publicApi.ts so that a test faking the API calls keeps these helpers real.
 */

import type { TokenProvider } from './client.js';

/**
 * Who the public pages are reading as (S46). `ready` is false while a tab that
 * holds a sign-in is still restoring it, and a page waits for it rather than
 * reading anonymously first - a private article would otherwise flash "not
 * found" before its reader's token arrived. `key` changes when the reader does
 * (a sign-in, a sign-out), which is what a page reloads its content on. `token`
 * is null for an anonymous reader.
 */
export interface PublicReader {
  ready: boolean;
  key: string;
  token: TokenProvider | null;
}

export const ANONYMOUS_READER: PublicReader = { ready: true, key: 'anonymous', token: null };

/**
 * A read that waits for the reader: nothing is fetched until `ready`, so the
 * page shows its loading state instead of an anonymous answer it would then
 * replace. The promise never settles while not ready; useAsync runs the loader
 * again when `ready` changes.
 */
export function forReader<T>(reader: PublicReader, load: () => Promise<T>): Promise<T> {
  return reader.ready ? load() : new Promise<T>(() => undefined);
}
